import React from "react";
import { Route } from "react-router-dom";
import './CatalogPage.css'
import Media from "react-media";
import {HeaderDesktop} from "../../components/header/desktop/HeaderDesktop";
import {HeaderMobile} from "../../components/header/mobile/HeaderMobile";
import { GoogleTagManagerService } from "../../services/analitycs/GoogleTagManagerService";
import { Button } from "@material-ui/core";
import { CatalogToggleSwitch } from "../../components/catalog-switch/CatalogToggleSwitch";
import { MposWebPortalApi } from "../../services/api/MposWebPortalApi";
import {ReactComponent as SearchIcon} from "../../resources/images/search.svg";
import { ServiceUnavailablePage } from "../service-unavailable-page/ServiceUnavailablePage";
import { CategoryButton } from "../../components/buttons/category-button/CategoryButton";
import { CategoryDto, ICategoryDto } from "../../models/CategoryDto";
import _ from "lodash";
import { CatalogState } from "../../states/CatalogState";
import Skeleton from "react-loading-skeleton";
import { eventDispatcher } from "../../services/events/EventDispatcher";
import { EventType } from "../../services/events/EventType";
import { CategoriesDto } from "../../models/CategoriesDto";
import $ from 'jquery';
import * as querystring from 'querystring';
import { ProductButton } from "../../components/buttons/product-button/ProductButton";
import { Pagination } from "../../utils/Pagination";
import { IProductDto } from "../../models/ProductDto";
import { DuplicateCategoryRequest } from "../../models/DuplicateCategoryRequest";
import { CategoryUtils } from "../../utils/CategoryUtils";
import { sessionStorageInstance } from "../../services/storage/Storage";
import { ICatalogDto } from "../../models/CatalogDto";
import { base64ToBlob } from "../../utils/FileUtils";
import FileSaver from "file-saver";
import moment from "moment";
import { dataStore } from "../../services/storage/DataStore";

export class CatalogPage extends React.Component<any, CatalogState> {
    private pagination: Pagination<IProductDto>;
    private subscription: any = undefined;
    constructor(props: any) {
        super(props);
        this.state = {
            categories: null,
            products: null,
            numberOfProducts: 0,
            numberOfCategories: 0,
            tabSelected: 0,
            getCatalogError: false,
            isLoaded: false,
            showLoader: false,
            updateView: false,
            productsToShow: [],
            productPageCounter: 0
        };

        this.onNewCategoryClickCallback = this.onNewCategoryClickCallback.bind(this);
        this.onChangeColorCallback = this.onChangeColorCallback.bind(this);
        this.onUpdateCategoryCallback = this.onUpdateCategoryCallback.bind(this);
        this.copyCategoryCallbackWithValue = this.copyCategoryCallbackWithValue.bind(this);
        this.deleteProductFromCatalog = this.deleteProductFromCatalog.bind(this);

        this.pagination = new Pagination(10);
    }

    componentDidMount(){
        console.log("[CatalogPage] didMount")
        this.setState({isLoaded: false});
        GoogleTagManagerService.getInstance().pushPageEvent(this.props.history.location.pathname, 'Catalogo', {});
        if(this.props.location.state !== undefined){
            const { data } = this.props.location.state;
            if(data !== undefined){
                if(data.operation !== undefined && data.operation === 'deleteCategoryFromDetails'){
                    window.history.pushState(null, '', '/');
                    window.history.pushState(null, '', '/catalog');
                    sessionStorageInstance.setData('useCache', '1');
                    let id = data.categoryId;
                    let name = data.name;
                    let color = data.color;
                    let categoryDto = new CategoryDto(id, color, name, null);
                    setTimeout(() => {
                        this.deleteCategoryCallback(categoryDto);
                    }, 1000);
                } else if(data.operation !== undefined && data.operation === 'copyCategoryFromDetails'){
                    window.history.pushState(null, '', '/');
                    window.history.pushState(null, '', '/catalog');
                    sessionStorageInstance.setData('useCache', '1');
                    let id = data.categoryId;
                    let name = data.name;
                    let color = data.color;
                    let categoryDto = new CategoryDto(id, color, name, null);
                    setTimeout(() => {
                        this.copyCategoryCallback(categoryDto);
                    }, 150);
                } else if(data.operation !== undefined && data.operation === 'deleteProductFromDetail'){
                    window.history.pushState(null, '', '/');
                    window.history.pushState(null, '', '/catalog');
                    sessionStorageInstance.setData('useCache', '1');
                    let productToDelete: IProductDto = data.toDelete;
                    if(productToDelete !== undefined){
                        console.log("[Delete product] product: " + productToDelete.productId);
                        setTimeout(() => {
                            this.setState({tabSelected: 1});
                            $([document.documentElement, document.body]).animate({
                                // @ts-ignore
                                scrollTop: $('#' + productToDelete.productId!).offset().top - 89
                            }, 350);
                            setTimeout(() => {
                                this.deleteProductFromCatalogWithoutReload(productToDelete);
                            }, 550);
                        }, 0); // Permit to call loadCatalog first and after set state on tab selected
                    }
                } else if(data.operation !== undefined && data.operation === 'deleteNoCategoryProducts'){
                    window.history.pushState(null, '', '/');
                    window.history.pushState(null, '', '/catalog');
                    sessionStorageInstance.setData('useCache', '1');
                    let id = data.categoryId;
                    let name = data.name;
                    let color = data.color;
                    let categoryDto = new CategoryDto(id, color, name, null);
                    setTimeout(() => {
                        this.deleteAllProductsOfNoCategory(categoryDto);
                    }, 150);
                }
            }
        }
        // Reset product cache because updated in category details but deleted in catalog
        dataStore.clearProductsData();
        // Reset cached product to try to insert
        dataStore.clearTryToInsertCache();
        dataStore.clearCategoryFromAddProduct();
        // Load catalog
        this.loadCatalog();
        window.scrollTo(0, 0);
    }

    componentDidUpdate(){
        if(this.state.updateView === true){
            this.setState({updateView: false});
        }

        let main = $('#main-container-catalog')
        if(main !== undefined){
            main.css('height', 'auto');
        }
    }

    componentWillUnmount(){
        if(this.subscription !== undefined){
            this.subscription.unsubscribe();
        }
    }

    private loadCatalog(){
        if(!sessionStorageInstance.hasKey('useCache')){
            this.subscription = MposWebPortalApi.getInstance().getCatalog().subscribe(data => {
                console.log("[CatalogPage] getCatalog API success");
                this.setState({categories: this.sortListForCategoryNameAndPutNoCategoryToFirst(data.categories)});
                this.setState({products: (data.products !== null && data.products !== undefined) ?
                    this.sortProductsForName(data.products) : []}, () => {
                        this.pagination.setInputData(this.sortProductsForName(this.state.products!!));
                        this.pagination.resetPaginator();
                        this.getProductsToShow();
                });
                this.setState({numberOfProducts: (data.products === undefined || data.products === null) ? 0 : data.products.length});
                this.setState({numberOfCategories: (data.categories === undefined || data.categories === null) ? 0 : this.getCategoriesNumber(data.categories)});
                this.setState({getCatalogError: false});
                this.setState({isLoaded: true});
                this.cacheCatalog(data);
            }, () => {
                console.log("[CatalogPage] getCatalog API failure");
                this.setState({categories: null});
                this.setState({products: null});
                this.setState({numberOfProducts: 0});
                this.setState({numberOfCategories: 0});
                this.setState({getCatalogError: true});
                this.setState({isLoaded: true});
            })
        } else {
            sessionStorageInstance.removeData('useCache');
            console.log("[CatalogPage] getCatalog Cached");
            let json = this.props.cachedCatalog;
            if(json !== null){
                let catalog = JSON.parse(json);
                this.setState({categories: this.sortListForCategoryNameAndPutNoCategoryToFirst(catalog.categories)});
                this.setState({products: (catalog.products !== null && catalog.products !== undefined) ?
                    this.sortProductsForName(catalog.products) : []}, () => {
                        this.setState({productsToShow: this.sortProductsForName(catalog.products)});
                });
                this.setState({numberOfProducts: (catalog.products === undefined || catalog.products === null) ? 0 : catalog.products.length});
                this.setState({numberOfCategories: (catalog.categories === undefined || catalog.categories === null) ? 0 : this.getCategoriesNumber(catalog.categories)});
                this.setState({getCatalogError: false});
                this.setState({isLoaded: true});
            } else {
                this.loadCatalog()
            }
        }
    }

    private static renderDesktopHeader(): JSX.Element {
        return (
            <HeaderDesktop showBack={false} showLogout={true} showTitle={false} selectedElement={1} title={"Catalogo"}/>);
    }
    private static renderMobileHeader(): JSX.Element {
        return (
            <HeaderMobile showBack={true} showLogout={true} showTitle={true} title={"il tuo CATALOGO prodotti"}/>);
    }

    private getProductsToShow(){
        this.setState({productsToShow: this.pagination.getNext()});
        this.setState({productPageCounter: this.pagination.getPageCounter()});
    }

    private sortProductsForName(products: IProductDto[]): IProductDto[] {
        if(products !== undefined && products !== null){
            return products.sort(function(a, b){
                if(a.name !== null && b.name !== null){
                    if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                    if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                }
                return 0;
            })
        }

        return [];
    }

    private sortListForCategoryNameAndPutNoCategoryToFirst(categories: ICategoryDto[] | null): ICategoryDto[] {
        if(categories !== null && categories !== undefined){
            let sorted = categories!!.sort(function(a, b){
                if(a.name != null && b.name != null){
                    if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                    if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                }

                return 0;
            })

            let index = _.indexOf(sorted, _.find(sorted, (value: ICategoryDto) => {
                return value.name?.toLowerCase() === 'senza categoria';
            }))

            if(index !== -1){
                this.arrayMove(sorted, index, 0);
                 // Hide no category if empty
                if(sorted[0].name?.toLowerCase() === 'senza categoria' && sorted[0].nProducts === "0"){
                    sorted.splice(0, 1);
                }

                return sorted;
            } else {
                return sorted;
            }
        }

        return [];
    }

    private getCategoriesNumber(categories: ICategoryDto[]): number {
        if(categories !== null && categories !== undefined){
            let index = _.indexOf(categories, _.find(categories, (value: ICategoryDto) => {
                return value.name?.toLowerCase() === 'senza categoria';
            }))

            if(index !== -1){
                return categories.length - 1;
            } else {
                return categories.length;
            }
        }

        return 0;
    }

    private goToAddProduct(history: any){
        console.log("[CatalogPage] goToAddProduct called!");
        history.push('/addProduct/first');
    }

    private handleToggleChanges(checked: boolean){
        console.log("[CatalogPage] handleToggleChanges called with " + checked);
        // if checked == false then the first tab else the second tab is selected. TabSelected to 0 means that Categories view is set, otherwise is Products view
        this.setState({tabSelected: checked === false ? 0 : 1}, () => {
            if(this.state.tabSelected === 1){
                this.pagination.resetPaginator();
                this.getProductsToShow();
            }
        });
    }

    private cacheCatalog(data: ICatalogDto){
        if(this.props.cachedCatalog !== undefined){
            dataStore.clearCachedCatalog();
            dataStore.publishCatalogData(JSON.stringify(data));
        } else {
            dataStore.publishCatalogData(JSON.stringify(data));
        }
    }

    private handleSearch(){
        // Search only products...
        this.props.history.push('/catalog/search', {products: this.state.products});
    }

    private handleDownloadCatalog(){
        // download catalog...
        this.subscription = MposWebPortalApi.getInstance().getCatalogFile().subscribe((response) => {
            let fileData = response.fileData;
            let blob = base64ToBlob(fileData, 'application/vnd.ms-excel;charset=utf-8');
            const dateFormat = 'YYYYMMDD_HHmmss';
            let currentDate = moment(new Date()).format(dateFormat);
            let fileName = 'mpos_catalogo_prodotti_' + currentDate + '.xls';
            FileSaver.saveAs(blob, fileName);
        }, () => {
            // show error page
            this.props.history.push('/result', {
                isSuccess: false,
                errorTitle: "Si è verificato un errore durante il download del file",
                message: "Riprova più tardi. Grazie per la pazienza",
                button: "TORNA AL CATALOGO",
                data: { from: "CatalogPage", operation: "downloadCatalog" }
            })
        });
    }

    private handleAddCategory(){
        // Send event to category button
        eventDispatcher.sendEvent(EventType.OPEN_NEW_CATEGORY_POPUP);
    }

    private goToCategoryDetails(history: any, category: ICategoryDto){
        // Method called when onClick on category's arrow button is propagated!
        console.log("[CatalogPage] goToCategoryDetails called with " + JSON.stringify(category));
        let queryParams = {color: category.color, name: category.name !== null ? encodeURIComponent(category.name) : ""};
        let link = `/category/${category.categoryId}?${querystring.stringify(queryParams)}`;
        history.push(link);
    }

    private onNewCategoryClickCallback(name: string, color: string){
        // Method called when onClick on create new category button on overlay popup is propagated!
        console.log("[CatalogPage] onNewCategoryClick with " + name + " and " + color);
        // This is the method when to add category
        let categoryToAdd = new CategoryDto(null, color, name, null);
        let categories = new CategoriesDto();
        categories.categories.push(categoryToAdd);
        this.subscription = MposWebPortalApi.getInstance().addCategory(categories).subscribe((result: boolean) => {
            console.log("[CatalogPage] POST category result: " + result);
            if(result){
                eventDispatcher.sendEvent(EventType.CLOSE_NEW_CATEGORY_POPUP);
                this.loadCatalog();
            } else {
                eventDispatcher.sendEvent(EventType.ERROR_NEW_CATEGORY_POPUP_ALREADY_EXISTS);
            }
        }, (error) => {
            console.log("[CatalogPage] POST category error: " + JSON.stringify(error));
            if(error.status === 400){
                eventDispatcher.sendEvent(EventType.ERROR_NEW_CATEGORY_POPUP_ALREADY_EXISTS);
            } else {
                eventDispatcher.sendEvent(EventType.ERROR_NEW_CATEGORY_POPUP_GENERIC_ERROR);
            }
        });
    }

    private onChangeColorCallback(id: string, color: string){
        // Method called when onChange on color overlay popup is propagated!
        console.log("[CatalogPage] onChangeColorCallback with " + id + " and " + color);
        if(this.state.categories !== null){
            let index = _.findIndex(this.state.categories, {categoryId: id});
            let old = this.state.categories;
            let category = old[index];
            let newCategory = new CategoryDto(category.categoryId, color, null, null);
            category.color = color;
            this.subscription = MposWebPortalApi.getInstance().updateCategory(newCategory).subscribe((result) => {
                console.log("[CatalogPage] onChangeColorCallback success " + result);
                if(result){
                    old.splice(index, 1, category);
                    this.setState({categories: old});
                }
            }, () => {
                console.log("[CatalogPage] onChangeColorCallback error");
            });
        }
    }

    private copyCategoryCallback(category: ICategoryDto){
        console.log("[CatalogPage] copyCategoryCallback " + JSON.stringify(category));
        let request = new DuplicateCategoryRequest(category.categoryId!!, null, null);
        this.subscription = MposWebPortalApi.getInstance().copyCategory(request).subscribe(() => {
            eventDispatcher.sendEvent(EventType.CLOSE_CATEGORY_POPUP);
            this.loadCatalog();
        }, (error) => {
            if(error.data !== undefined){
                let statusCode = error.data.statusCode;
                if(statusCode === "4300"){
                    //@ts-ignore
                    let place = CategoryUtils.getData(category.name!!).place;
                    eventDispatcher.sendEvent(EventType.CLOSE_CATEGORY_POPUP);
                    eventDispatcher.sendEventWithData(EventType.ERROR_COPY_CATEGORY, {failedName: error.data.message, category: category, place: place});
                } else if(statusCode === "400"){
                    eventDispatcher.sendEvent(EventType.ERROR_UPDATE_CATEGORY_POPUP_ALREADY_EXISTS)
                } else {
                    eventDispatcher.sendEvent(EventType.ERROR_UPDATE_CATEGORY_POPUP_GENERIC_ERROR)
                }
            }
        });
    }

    private copyCategoryCallbackWithValue(id: string, name: string, color: string){
        console.log("[CatalogPage] copyCategoryCallbackWithValue with " + id);
        let request = new DuplicateCategoryRequest(id, name, color);
        this.subscription = MposWebPortalApi.getInstance().copyCategory(request).subscribe(() => {
            eventDispatcher.sendEvent(EventType.CLOSE_CATEGORY_POPUP);
            this.loadCatalog();
        }, (error) => {
            if(error.data !== undefined){
                let statusCode = error.data.statusCode;
                if(statusCode === "4300"){
                    //@ts-ignore
                    let place = CategoryUtils.getData(category.name!!).place;
                    let categoryDto = new CategoryDto(id, color, name, null);
                    eventDispatcher.sendEvent(EventType.CLOSE_CATEGORY_POPUP);
                    eventDispatcher.sendEventWithData(EventType.ERROR_COPY_CATEGORY, {failedName: error.data.message, category: categoryDto, place: place});
                } else if(statusCode === "4000"){
                    eventDispatcher.sendEvent(EventType.ERROR_UPDATE_CATEGORY_POPUP_ALREADY_EXISTS)
                } else {
                    eventDispatcher.sendEvent(EventType.ERROR_UPDATE_CATEGORY_POPUP_GENERIC_ERROR)
                }
            }
        });
    }

    private deleteCategoryCallback(category: ICategoryDto){
        console.log("[CatalogPage] deleteCategoryCallback " + JSON.stringify(category));
        if(this.state.categories !== null){
            let index = _.findIndex(this.state.categories, {categoryId: category.categoryId});
            let old = this.state.categories;
            this.subscription = MposWebPortalApi.getInstance().deleteCategory(category).subscribe((result) => {
                eventDispatcher.sendEvent(EventType.CLOSE_CATEGORY_POPUP);
                console.log("[CatalogPage] deleteCategoryCallback success " + result);
                old.splice(index, 1);
                //this.loadCatalog();
                if(result){
                    this.runDeleteAnimation(category, () => {
                        console.log("[CatalogPage] delete called!");
                        this.setState({categories: old}, () => {
                            // Call getCategories silently
                            MposWebPortalApi.getInstance().getCategories().subscribe((data) => {
                                this.setState({categories: this.sortListForCategoryNameAndPutNoCategoryToFirst(data.categories)});
                                this.setState({numberOfCategories: (data.categories === undefined || data.categories === null) ? 0 : this.getCategoriesNumber(data.categories)});
                            }, () => {
                                // Nothing to do
                            })
                        });
                    });
                } else {
                    // show error page
                    this.props.history.push('/result', {
                        isSuccess: false,
                        errorTitle: "Si è verificato un errore durante la cancellazione della categoria.",
                        message: "Riprova più tardi. Grazie per la pazienza",
                        button: "TORNA AL CATALOGO",
                        data: { from: "CatalogPage", operation: "deleteCategory" }
                    })
                }
            }, () => {
                eventDispatcher.sendEvent(EventType.CLOSE_CATEGORY_POPUP);
                console.log("[CatalogPage] deleteCategoryCallback error ");
                // show error page
                this.props.history.push('/result', {
                    isSuccess: false,
                    errorTitle: "Si è verificato un errore durante la cancellazione della categoria.",
                    message: "Riprova più tardi. Grazie per la pazienza",
                    button: "TORNA AL CATALOGO",
                    data: { from: "CatalogPage", operation: "deleteCategory" }
                })
            });
        }
    }

    private runDeleteAnimation(category: ICategoryDto, callback: any){
        let name = category!.categoryId!
        $('#' + name).addClass('remove-animation');
        $('#' + name).on('transitionend webkitTransitionEnd oTransitionEnd', function() {
            $('#' + name).removeClass('remove-animation');
            callback();
        });
    }

    private deleteAllProductsOfNoCategory(category: ICategoryDto){
        console.log("[CatalogPage] deleteAllProductsOfNoCategory " + JSON.stringify(category));
        let filteredProducts = _.filter(this.state.products, (value: IProductDto) => {
            return _.find(value.categories, (filter: ICategoryDto) => {
                return filter.categoryId === category.categoryId;
            });
        });
        console.log("[CatalogPage] No category to delete: " + filteredProducts.length);
        let itemProcessed = 0;
        for(let i = 0; i < filteredProducts.length; i++){
            //@ts-ignore
            let product: IProductDto = filteredProducts[i];
            this.subscription = MposWebPortalApi.getInstance().deleteProduct(product).subscribe(() => {
                itemProcessed++;
                if(itemProcessed === filteredProducts.length){
                    eventDispatcher.sendEvent(EventType.CLOSE_CATEGORY_POPUP);
                    this.runDeleteAnimation(category, () => {
                        let index = _.findIndex(this.state.categories, {categoryId: category.categoryId});
                        let old = this.state.categories;
                        old?.splice(index, 1);
                        this.setState({categories: old}, () => {
                            this.loadCatalog();
                        });
                    });
                }
            }, (error) => {
                eventDispatcher.sendEvent(EventType.CLOSE_CATEGORY_POPUP);
                this.setState({getCatalogError: true});
            })
        }
    }

    private onUpdateCategoryCallback(id: string, name: string, color: string){
         // Method called when click modify category on overlay popup is propagated!
        console.log("[CatalogPage] updateCategory with " + id + " and " + name + " and " + color);
        if(this.state.categories !== null){
            let index = _.findIndex(this.state.categories, {categoryId: id});
            let old = this.state.categories;
            let category = old[index];
            let dto = new CategoryDto(category.categoryId, color, name, category.nProducts);
            this.subscription = MposWebPortalApi.getInstance().updateCategory(dto).subscribe((result) => {
                console.log("[CatalogPage] updateCategory success " + result);
                if(result){
                    eventDispatcher.sendEvent(EventType.CLOSE_CATEGORY_POPUP);
                    this.loadCatalog();
                } else {
                    eventDispatcher.sendEvent(EventType.ERROR_UPDATE_CATEGORY_POPUP_ALREADY_EXISTS);
                }
            }, (error) => {
                console.log("[CatalogPage] updateCategory error");
                if(error.status === 400){
                    eventDispatcher.sendEvent(EventType.ERROR_UPDATE_CATEGORY_POPUP_ALREADY_EXISTS);
                } else {
                    eventDispatcher.sendEvent(EventType.ERROR_UPDATE_CATEGORY_POPUP_GENERIC_ERROR);
                }
            });
        }
    }

    private deleteProductFromCatalog(product: IProductDto){
        let index = _.findIndex(this.state.products, {productId: product.productId});
        let old = this.state.products!;
        this.subscription = MposWebPortalApi.getInstance().deleteProduct(product).subscribe((response) => {
            eventDispatcher.sendEvent(EventType.CLOSE_PRODUCT_POPUP);
            if(response){
                this.productCompleteDeleteAnimation(product, () => {
                    console.log("[CatalogPage] called!");
                    old.splice(index, 1);
                    this.setState({products: old}, () => {
                        this.setState({numberOfProducts: this.state.products?.length!});
                        this.loadCatalog();
                    });
                });
            } else {
                this.props.history.push('/result', {
                    isSuccess: false,
                    errorTitle: "Si è verificato un errore durante la cancellazione del prodotto.",
                    message: "Riprova più tardi. Grazie per la pazienza",
                    button: "TORNA AL CATALOGO",
                    data: { from: "CatalogPage", operation: "deleteCategory" }
                })
            }
        }, () => {
            eventDispatcher.sendEvent(EventType.CLOSE_PRODUCT_POPUP);
            this.props.history.push('/result', {
                isSuccess: false,
                errorTitle: "Si è verificato un errore durante la cancellazione del prodotto.",
                message: "Riprova più tardi. Grazie per la pazienza",
                button: "TORNA AL CATALOGO",
                data: { from: "CatalogPage", operation: "deleteCategory" }
            })
        })
    }

    private deleteProductFromCatalogWithoutReload(product: IProductDto){
        let index = _.findIndex(this.state.products, {productId: product.productId});
        let old = this.state.products!;
        this.subscription = MposWebPortalApi.getInstance().deleteProduct(product).subscribe((response) => {
            eventDispatcher.sendEvent(EventType.CLOSE_PRODUCT_POPUP);
            if(response){
                this.runProductDeleteAnimation(product, () => {
                    console.log("[CatalogPage] called!")
                    old.splice(index, 1);
                    this.setState({products: old}, () => {
                        this.setState({numberOfProducts: this.state.products?.length!});
                    });
                });
            } else {
                this.props.history.push('/result', {
                    isSuccess: false,
                    errorTitle: "Si è verificato un errore durante la cancellazione del prodotto.",
                    message: "Riprova più tardi. Grazie per la pazienza",
                    button: "TORNA AL CATALOGO",
                    data: { from: "CatalogPage", operation: "deleteCategory" }
                })
            }
        }, () => {
            eventDispatcher.sendEvent(EventType.CLOSE_PRODUCT_POPUP);
            this.props.history.push('/result', {
                isSuccess: false,
                errorTitle: "Si è verificato un errore durante la cancellazione del prodotto.",
                message: "Riprova più tardi. Grazie per la pazienza",
                button: "TORNA AL CATALOGO",
                data: { from: "CatalogPage", operation: "deleteCategory" }
            })
        })
    }

    private runProductDeleteAnimation(product: IProductDto, callback: any){
        let id = product.productId!;
        $('#' + id).addClass('remove-animation');
        $('#' + id).on('transitionend webkitTransitionEnd oTransitionEnd', function() {
            $('#' + id).removeClass('remove-animation');
            callback();
        });
    }

    private productCompleteDeleteAnimation(product: IProductDto, callback: any){
        let id = product.productId!;
        $('#' + id).addClass('remove-animation');
        $('#' + id).on('transitionrun webkitTransitionRun oTransitionRun', function() {
            setTimeout(() => {
                callback();
            }, 0);
        });
        $('#' + id).on('transitionend webkitTransitionEnd oTransitionEnd', function() {
            $('#' + id).removeClass('remove-animation');
        });
    }


    private renderCategoriesTab(): JSX.Element {
        return <div>
            <Media query="(min-width: 1065px)" render={() => {
                return <div className="catalog-tab-content-header-row" style={{marginBottom: this.state.tabSelected === 0 ? 20 : 25}}>
                    <div className="catalog-tab-content-header-column-one">
                        <SearchIcon className={this.state.numberOfProducts > 0 ? "catalog-tab-content-search-icon" : "catalog-tab-content-search-icon-disabled"}
                        onClick={this.state.numberOfProducts > 0 ? () => {this.handleSearch()} : () => {}}/>
                        <div className={"catalog-tab-content-divider"}/>
                        {
                            this.state.numberOfCategories === 1 ? <p className={"catalog-tab-counter"}><strong>{this.state.numberOfCategories}</strong> Categoria creata</p> :
                            <p className={"catalog-tab-counter"}><strong>{this.state.numberOfCategories}</strong> Categorie create</p>
                        }
                    </div>
                    <div className="catalog-tab-content-header-column-two">
                        <Button id={"catalog-button-download"} disableRipple={true} disabled={this.state.numberOfProducts === 0} onClick={() => {
                                this.handleDownloadCatalog();
                        }}>SCARICA</Button>
                        <div className={"catalog-tab-content-divider"}/>
                        <Button id={"catalog-button-new-category"} disableRipple={true} onClick={() => {
                                this.handleAddCategory();
                        }}>CREA CATEGORIA</Button>
                        <div className={"catalog-tab-content-divider"}/>
                        <Route render={({history}) => {
                            return <Button id={"catalog-button-add-product"} onClick={() => {
                                this.goToAddProduct(history);
                            }}>AGGIUNGI PRODOTTO</Button>;
                        }}/>
                    </div>
                </div>
            }}/>
            <Media query="(max-width: 1064px)" render={() => {
                return <div className="catalog-tab-content-header-row">
                    <div className={"catalog-tab-content-header-column-one"}>
                        <Route render={({history}) => {
                                return <Button id={"catalog-button-add-product"} onClick={() => {
                                    this.goToAddProduct(history);
                                }}>AGGIUNGI PRODOTTO</Button>;
                            }}/>
                    </div>
                    <div className={"catalog-tab-content-header-column-two"}>
                        <SearchIcon className={this.state.numberOfProducts > 0 ? "catalog-tab-content-search-icon" : "catalog-tab-content-search-icon-disabled"}
                            onClick={this.state.numberOfProducts > 0 ? () => {this.handleSearch()} : () => {}}/>
                        <div className={"catalog-tab-content-divider"}/>
                        <Button id={"catalog-button-download"} disableRipple={true} disabled={this.state.numberOfProducts === 0} onClick={() => {
                                this.handleDownloadCatalog();
                        }}>SCARICA</Button>
                        <div className={"catalog-tab-content-divider"}/>
                        <Button id={"catalog-button-new-category"} disableRipple={true} onClick={() => {
                                this.handleAddCategory();
                        }}>CREA CATEGORIA</Button>
                    </div>
                    <div className={"catalog-tab-content-header-column-three"}>
                        {
                            this.state.numberOfCategories === 1 ? <p className={"catalog-tab-counter"}><strong>{this.state.numberOfCategories}</strong> Categoria creata</p> :
                            <p className={"catalog-tab-counter"}><strong>{this.state.numberOfCategories}</strong> Categorie create</p>
                        }
                    </div>
                </div>
            }}/>
        </div>
    }

    private renderProductsTab(): JSX.Element {
        return <div>
            <Media query="(min-width: 1065px)" render={() => {
                return <div className="catalog-tab-content-header-row">
                    <div className="catalog-tab-content-header-column-one">
                        <SearchIcon className={this.state.numberOfProducts > 0 ? "catalog-tab-content-search-icon" : "catalog-tab-content-search-icon-disabled"}
                            onClick={this.state.numberOfProducts > 0 ? () => {this.handleSearch()} : () => {}}/>
                        <div className={"catalog-tab-content-divider"}/>
                        {
                            this.state.numberOfProducts === 1 ? <p className={"catalog-tab-counter"}><strong>{this.state.numberOfProducts}</strong> Prodotto inserito</p> :
                            <p className={"catalog-tab-counter"}><strong>{this.state.numberOfProducts}</strong> Prodotti inseriti</p>
                        }
                    </div>
                    <div className="catalog-tab-content-header-column-two">
                        <Button id={"catalog-button-download"} disableRipple={true} disabled={this.state.numberOfProducts === 0} onClick={() => {
                                this.handleDownloadCatalog();
                        }}>SCARICA</Button>
                        <div className={"catalog-tab-content-divider"}/>
                        <Route render={({history}) => {
                            return <Button id={"catalog-button-add-product"} onClick={() => {
                                this.goToAddProduct(history);
                            }}>AGGIUNGI PRODOTTO</Button>;
                        }}/>
                    </div>
                </div>
            }}/>
            <Media query="(max-width: 1064px)" render={() => {
                return <div className="catalog-tab-content-header-row">
                    <div className={"catalog-tab-content-header-column-one"}>
                        <Route render={({history}) => {
                                return <Button id={"catalog-button-add-product"} onClick={() => {
                                    this.goToAddProduct(history);
                                }}>AGGIUNGI PRODOTTO</Button>;
                            }}/>
                    </div>
                    <div className={"catalog-tab-content-header-column-two"}>
                        <SearchIcon className={this.state.numberOfProducts > 0 ? "catalog-tab-content-search-icon" : "catalog-tab-content-search-icon-disabled"}
                            onClick={this.state.numberOfProducts > 0 ? () => {this.handleSearch()} : () => {}}/>
                        <div className={"catalog-tab-content-divider"}/>
                        <Button id={"catalog-button-download"} disableRipple={true} disabled={this.state.numberOfProducts === 0} onClick={() => {
                                this.handleDownloadCatalog();
                        }}>SCARICA</Button>
                    </div>
                    <div className={"catalog-tab-content-header-column-three"}>
                        {
                            this.state.numberOfProducts === 1 ? <p className={"catalog-tab-counter"}><strong>{this.state.numberOfProducts}</strong> Prodotto inserito</p> :
                            <p className={"catalog-tab-counter"}><strong>{this.state.numberOfProducts}</strong> Prodotti inseriti</p>
                        }
                    </div>
                </div>
            }}/>
        </div>
    }

    renderCategories(): JSX.Element {
        CategoryUtils.resetCachedInfo();
        // Manage also no category button
        // for props, undefined means create new category button, null means create no category button
        let elements = new Array<JSX.Element[]>();
        let temporary: JSX.Element[] = [];
        _.forEach(this.state.categories, (value: ICategoryDto, index: number) => {
            if(temporary.length === 0){
                CategoryUtils.putData(value.name!!, 1);
                temporary.push(
                    <div key={index} className={"category-column-left"}><Route render={({history}) => {
                        return <CategoryButton category={value} goToPage={() => this.goToCategoryDetails(history, value)} place={1}
                           changeColorFromMenu={this.onChangeColorCallback} addProductCallback={() => this.goToAddProduct(history)}
                           copyCategory={() => this.copyCategoryCallback(value)} deleteCategory={() => this.deleteCategoryCallback(value)}
                           deleteAllProductsInNoCategory={() => this.deleteAllProductsOfNoCategory(value)} updateCategory={this.onUpdateCategoryCallback}
                           copyCategoryWithValue={this.copyCategoryCallbackWithValue}/>
                    }}/></div>
                );
                if(index === (this.state.categories?.length! - 1)){
                    elements.push(temporary);
                    temporary = [];
                }
            } else if(temporary.length === 1){
                CategoryUtils.putData(value.name!!, 2);
                temporary.push(
                    <div key={index} className={"category-column-center"}><Route render={({history}) => {
                        return <CategoryButton category={value} goToPage={() => this.goToCategoryDetails(history, value)} place={2}
                            changeColorFromMenu={this.onChangeColorCallback} addProductCallback={() => this.goToAddProduct(history)}
                            copyCategory={() => this.copyCategoryCallback(value)} deleteCategory={() => this.deleteCategoryCallback(value)}
                            deleteAllProductsInNoCategory={() => this.deleteAllProductsOfNoCategory(value)} updateCategory={this.onUpdateCategoryCallback}
                            copyCategoryWithValue={this.copyCategoryCallbackWithValue}/>
                    }}/></div>
                );
                if(index === (this.state.categories?.length! - 1)){
                    elements.push(temporary);
                    temporary = [];
                }
            } else if(temporary.length === 2){
                CategoryUtils.putData(value.name!!, 3);
                temporary.push(
                    <div key={index} className={"category-column-right"}><Route render={({history}) => {
                        return <CategoryButton category={value} goToPage={() => this.goToCategoryDetails(history, value)} place={3}
                            changeColorFromMenu={this.onChangeColorCallback} addProductCallback={() => this.goToAddProduct(history)}
                            copyCategory={() => this.copyCategoryCallback(value)} deleteCategory={() => this.deleteCategoryCallback(value)}
                            deleteAllProductsInNoCategory={() => this.deleteAllProductsOfNoCategory(value)} updateCategory={this.onUpdateCategoryCallback}
                            copyCategoryWithValue={this.copyCategoryCallbackWithValue}/>
                    }}/></div>
                );
                elements.push(temporary);
                temporary = [];
            }
        });

        // Add new category button
        let last: JSX.Element[] = elements[elements.length - 1];
        if(last !== undefined){
            if(last.length === 3){
                // Row complete, add new row with create category button
                let container = [];
                container.push(<div className="category-column-left" key={-1}>
                    <CategoryButton category={undefined} place={1} onNewCategoryClick={this.onNewCategoryClickCallback}/>
                </div>)
                elements.push(container);
            } else {
                if(last.length === 1){
                    // Center
                    elements[elements.length - 1].push(
                        <div className="category-column-center" key={-1}><CategoryButton category={undefined} place={2} onNewCategoryClick={this.onNewCategoryClickCallback}/></div>
                    );
                } else {
                    // Right
                    elements[elements.length - 1].push(
                        <div className="category-column-right" key={-1}><CategoryButton category={undefined} place={3} onNewCategoryClick={this.onNewCategoryClickCallback}/></div>
                    );
                }
            }
        } else {
            // No element
            elements.push([]);
            // Left
            elements[elements.length - 1].push(
                <div className="category-column-left" key={-1}><CategoryButton category={undefined} place={2} onNewCategoryClick={this.onNewCategoryClickCallback}/></div>
            );
        }

        return <div className={"catalog-categories-main"}>
            {
                _.map(elements, (rowElements) => {
                    return <div className={"category-table-row"}>
                        {_.map(rowElements, (columnElement) => {
                            return columnElement;
                        })}
                    </div>
                })
            }
        </div>
    }

    renderProducts(): JSX.Element {
        let elements = new Array<JSX.Element[]>();
        let temporary: JSX.Element[] = [];
        _.forEach(this.state.productsToShow, (value: IProductDto, index: number) => {
            if((index % 2) === 0){
                temporary.push(
                    <div className={"catalog-product-column catalog-product-column-left"}>
                        <Route render={({history}) => {
                            return <ProductButton product={value} history={history} page={'CatalogPage'} deleteFromCatalog={this.deleteProductFromCatalog}/>
                        }} />
                    </div>
                )
            } else {
                temporary.push(
                    <div className={"catalog-product-column catalog-product-column-right"}>
                        <Route render={({history}) => {
                            return <ProductButton product={value} history={history} page={'CatalogPage'} deleteFromCatalog={this.deleteProductFromCatalog}/>
                        }} />
                    </div>
                )
            }

            if(temporary.length === 2){
                elements.push(temporary);
                temporary = [];
            } else {
                if(index === (this.state.productsToShow?.length! - 1)){
                    elements.push(temporary);
                    temporary = [];
                }
            }
        });

        return (<div className={"catalog-product-table-container"}>
            {
                _.map(elements, (rowElements) => {
                    return <div className={"catalog-product-row"}>
                        {_.map(rowElements, (columnElement) => {
                            return columnElement;
                        })}
                    </div>
                })
            }
        </div>)
    }

    render() {
        return (
            this.state.getCatalogError ? <ServiceUnavailablePage/> : <div id={"main-container-catalog"}>
                <Media query="(max-width: 1064px)" render={() => CatalogPage.renderMobileHeader() }/>
                <Media query="(min-width: 1065px)" render={() => CatalogPage.renderDesktopHeader() }/>
                <div className={"catalog-container-content"}>
                    <p className={"catalog-title"}>
                    Crea ed organizza il tuo catalogo per te e il tuo staff che usa l'app di Nexi POS.
                    </p>
                    <CatalogToggleSwitch first={"CATEGORIE"} second={"PRODOTTI"} notifyChanges={(value: boolean) => {
                        this.handleToggleChanges(value);
                    }} defaultValue={this.props.tabSelected}/>
                    <div className={"catalog-row"}></div>
                    <div className={"catalog-tab-content"}>
                        {this.state.tabSelected === 0 ? this.renderCategoriesTab() : this.renderProductsTab()}
                    </div>
                    {
                        this.state.tabSelected === 0 ? (this.state.isLoaded || this.state.updateView) ? this.renderCategories() : (
                            <div className={"category-table-row"}>
                                <Skeleton className={"category-skeleton-main category-column-left"}/>
                                <Skeleton className={"category-skeleton-main category-column-center"}/>
                                <Skeleton className={"category-skeleton-main category-column-right"}/>
                            </div>
                        ) :  this.renderProducts()
                    }
                    {
                        this.state.tabSelected === 1 ? (this.state.isLoaded || this.state.updateView) ? this.pagination.hasMoreElements() && <Button id={"catalog-product-show-more"} onClick={() => {this.getProductsToShow()}} disableRipple>{"Mostra di più".toUpperCase()}</Button> :
                        <div className={"catalog-product-table-container"}>
                            <div className={"catalog-product-row"}>
                                <div className={"category-details-product-column category-details-product-column-left"}>
                                    <Skeleton className={"category-details-product-skeleton"}/>
                                </div>
                                <div className={"category-details-product-column category-details-product-column-right"}>
                                    <Skeleton className={"category-details-product-skeleton"}/>
                                </div>
                            </div>
                            <div className={"catalog-product-row"}>
                                <div className={"category-details-product-column category-details-product-column-left"}>
                                    <Skeleton className={"category-details-product-skeleton"}/>
                                </div>
                                <div className={"category-details-product-column category-details-product-column-right"}>
                                    <Skeleton className={"category-details-product-skeleton"}/>
                                </div>
                            </div>
                            <div className={"catalog-product-row"}>
                                <div className={"category-details-product-column category-details-product-column-left"}>
                                    <Skeleton className={"category-details-product-skeleton"}/>
                                </div>
                                <div className={"category-details-product-column category-details-product-column-right"}>
                                    <Skeleton className={"category-details-product-skeleton"}/>
                                </div>
                            </div>
                            <div className={"catalog-product-row"}>
                                <div className={"category-details-product-column category-details-product-column-left"}>
                                    <Skeleton className={"category-details-product-skeleton"}/>
                                </div>
                                <div className={"category-details-product-column category-details-product-column-right"}>
                                    <Skeleton className={"category-details-product-skeleton"}/>
                                </div>
                            </div>
                            <div className={"catalog-product-row"}>
                                <div className={"category-details-product-column category-details-product-column-left"}>
                                    <Skeleton className={"category-details-product-skeleton"}/>
                                </div>
                                <div className={"category-details-product-column category-details-product-column-right"}>
                                    <Skeleton className={"category-details-product-skeleton"}/>
                                </div>
                            </div>
                        </div> : undefined
                    }
                </div>
            </div>
        );
    }

    private arrayMove(array: any, oldIndex: number, newIndex: number): any {
        if (newIndex >= array.length) {
            var k = newIndex - array.length + 1;
            while (k--) {
                array.push(undefined);
            }
        }
        array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
        return array;
    };
}
